<zui-status-icon-base
  class="__icon-base"
  [size]="size"
  [status]="status"
  [statusText]="statusText"
  [tooltip]="tooltip">
</zui-status-icon-base>
